import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@shared/lib/http/axiosBaseQuery";
import { Entry, EntriesListSchema } from "@models/entry";

export const entriesApi = createApi({
  reducerPath: "entriesApi",
  baseQuery: axiosBaseQuery({ baseUrl: "/api/" }),
  tagTypes: ["entries"],
  endpoints: (b) => ({

    getEntriesByAccountId: b.query<Entry[], number>({
      query: getEntriesByAccountIdQuery,
      transformResponse: parseEntriesListResponse,
      providesTags: getEntriesByAccountIdProvidesTags,
    }),

  }),
});

export const {
  useGetEntriesByAccountIdQuery,
} = entriesApi;


/**
 * Validates an entries list API payload.
 * @param response unknown - Raw response body from axiosBaseQuery.
 * @returns Entry[] - Parsed entry rows.
 */
function parseEntriesListResponse(response: unknown): Entry[] {

  return EntriesListSchema.parse(response);
}


/**
 * Builds the axios request to load entries for an account.
 * @param accountId number - Account primary key.
 * @returns object - URL, method, and query params for GET entries.
 */
function getEntriesByAccountIdQuery(accountId: number) {

  return {
    url: "entries",
    method: "GET" as const,
    params: {
      "filter[account_id]": accountId,
      include: "document.documentSettings",
      sort: "id",
    },
  };
}


/**
 * Resolves RTK Query cache tags for entries loaded by account id.
 * @param _res Entry[] | undefined - Successful query result (unused).
 * @param _err unknown - Query error (unused).
 * @param accountId number - Account primary key from query args.
 * @returns Array - Cache tag keyed by account id.
 */
function getEntriesByAccountIdProvidesTags(_res: Entry[] | undefined, _err: unknown, accountId: number) {

  return [{ type: "entries" as const, id: accountId }];
}
